import { render } from "./productCategoryId.vue?vue&type=template&id=302e19e6&scoped=true"
import script from "./productCategoryId.vue?vue&type=script&lang=js"
export * from "./productCategoryId.vue?vue&type=script&lang=js"

import "./productCategoryId.vue?vue&type=style&index=0&id=302e19e6&lang=scss&scoped=true"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-302e19e6"]])

export default __exports__